module.exports = __webpack_public_path__ + "static/Luxury Management-e74192ff377576838ac21872b1cb5398.pdf";